export default "__VITE_ASSET__DhtKmKOw__"